import { Record } from 'immutable';
import { ConfigLevelType } from './config-level-type';
import { ConfigLookupType } from './config-lookup-type';

const ConfigResponseRecord = Record({
  config: null,
  value: null,
  level: null
});

export class ConfigResponse extends ConfigResponseRecord {
  config: ConfigLookupType;
  value: string;
  level: ConfigLevelType;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/config/config-response.ts